import { useState } from "react"
import { useTranslation } from "react-i18next"

import { Button } from "@/components/ui/button"
import {
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog"

export function DialogGoOfflineWithContact({
  callReportSaved,
  onClose,
  onConfirm,
}: {
  callReportSaved: boolean
  onClose: (value: boolean) => void
  onConfirm: () => Promise<void>
}) {
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)

  const handleGoOffline = async () => {
    try {
      setIsLoading(true)
      await onConfirm()
      onClose(true)
    } catch {
      setIsLoading(false)
    }
  }

  return (
    <DialogContent isPending={isLoading}>
      <DialogHeader>
        <DialogTitle>{t("global.modals.goOffline.title")}</DialogTitle>
      </DialogHeader>
      <DialogBody>
        {callReportSaved
          ? t("global.modals.goOffline.submitDescription")
          : t("global.modals.goOffline.skipDescription")}
      </DialogBody>
      <DialogFooter>
        <Button variant="outline" onClick={() => onClose(false)}>
          {t("global.button.cancel")}
        </Button>
        <Button onClick={() => handleGoOffline()} isLoading={isLoading}>
          {callReportSaved
            ? t("global.button.confirmAndGoOffline")
            : t("global.button.skip")}
        </Button>
      </DialogFooter>
    </DialogContent>
  )
}
